import { FC } from 'react'
import MockImage from '@images/ExerciseHistoryMock.png'
import './image.css'

export const Image: FC<{ src?: string }> = ({ src }) => {
	const imageSrc = src ? src : MockImage

	return (
		<div className="training-exercise-preview-frame" aria-hidden="true">
			<div className="training-exercise-preview-surface" />
			<img className="training-exercise-preview-image" src={imageSrc} alt="" />
		</div>
	)
}
